export class IdentityUserUpdateRolesDto {
  roleNames!: string[]
}
